export const panels = [
  { id: 1, name: "PLATINUM" },
  { id: 2, name: "GOLD" },
  { id: 3, name: "SILVER" },
  { id: 4, name: "BRONZE" },
  { id: 5, name: "NETWORKING" },
  { id: 6, name: "EXHIBITOR" },
  { id: 7, name: "ASSOCIATION" },
  { id: 8, name: "VISITOR" },
  { id: 9, name: "MEDIA" },
];

export const sponsorDefaultValues = () => ({ isActive: true });
